export default "__VITE_ASSET__933ad848__";